import React from "react";
import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { PageHead } from "../components/dpa/dpaUtils";
import { OrganisationsTab } from "../components/dpa/OrganisationsTab";
import { TemplatesTab } from "../components/dpa/TemplatesTab";
import { ProviderProfileTab } from "../components/dpa/ProviderProfileTab";
import { DpaAuditTab } from "../components/dpa/DpaAuditList";
import { RemindersTab } from "../components/dpa/RemindersTab";

export default function CompliancePage() {
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") || "agreements";
  return (
    <div className="p-8 space-y-6 fade-up" data-testid="compliance-page">
      <PageHead kicker="Super Admin · Compliance" title="Data Processing Agreements"
        sub="Castlewood Software DPA management — provider identity, master templates and each client organisation's agreement." />
      <Tabs value={tab} onValueChange={(v) => setParams({ tab: v })}>
        <TabsList className="rounded-none">
          <TabsTrigger value="agreements" className="rounded-none" data-testid="tab-agreements">Agreements</TabsTrigger>
          <TabsTrigger value="templates" className="rounded-none" data-testid="tab-templates">Master templates</TabsTrigger>
          <TabsTrigger value="provider" className="rounded-none" data-testid="tab-provider">Castlewood Software Profile</TabsTrigger>
          <TabsTrigger value="reminders" className="rounded-none" data-testid="tab-reminders">Reminders</TabsTrigger>
          <TabsTrigger value="audit" className="rounded-none" data-testid="tab-audit">Audit activity</TabsTrigger>
        </TabsList>
        <TabsContent value="agreements" className="mt-5"><OrganisationsTab /></TabsContent>
        <TabsContent value="templates" className="mt-5"><TemplatesTab /></TabsContent>
        <TabsContent value="provider" className="mt-5"><ProviderProfileTab /></TabsContent>
        <TabsContent value="reminders" className="mt-5"><RemindersTab /></TabsContent>
        <TabsContent value="audit" className="mt-5"><DpaAuditTab /></TabsContent>
      </Tabs>
    </div>
  );
}
